import { Box } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  padding: 16px 8px 16px 8px;
  width: 100%;
`;

export const Link = styled.a`
  text-decoration: none; /* Remove underline */
  color: inherit; /* Inherit text color from parent */
  cursor: pointer; /* Use pointer cursor on hover, mimicking a link */

  /* Optionally, style the link on hover or focus for better user feedback */
  &:hover {
    text-decoration: none; /* Add underline on hover or focus */
    color: inherit; /* Change color on hover or focus */
    background-color: inherit;
  }
  &:focus {
    text-decoration: none; /* Add underline on hover or focus */
    color: inherit; /* Change color on hover or focus */
  }
`;
